export const REGISTER = 'ACTION_AUTH_REGISTER';
export const FETCH_USER = 'FETCH_USER';
export const UPDATE_USER = 'UPDATE_USER';
export const ADD_USER = 'ADD_USER';
export const ERROR = 'ERROR';
export const LOGIN = 'ACTION_AUTH_LOGIN';
export const LOGOUT = 'ACTION_AUTH_LOGOUT';
export const PROCESSING = 'ACTION_AUTH_PROCESSING';
